import { Spinner } from "react-bootstrap"

export const LoadingPage = () => {
  return(
    <div className="center-content loading-page-container">
      <Spinner className = 'big-spinner' animation="border" role="status">
      </Spinner>
    </div>
  )
}